query getProductCateogoryData(
  $baseSiteId: BaseSiteId!
  $language: String!
  $id: String!
  $getSubCategories: Boolean = false
  $publicAssortment: Boolean
  $salesChannels: [String]
) {
  getCategoryById(
    baseSiteId: $baseSiteId
    language: $language
    id: $id
    publicAssortment: $publicAssortment
    salesChannels: $salesChannels
  ) {
    CategoryName
    TextList {
      Key
      Value
    }
    CategoryPath
    childCategories: subCategories(
      baseSiteId: $baseSiteId
      apiLang: $language
    ) @include(if: $getSubCategories) {
      CategoryId
      CategoryName
      Slug
      imageUrl: getMediaUrl(outputType: "PR", nameConvention: "P_G_F")
    }
  }
}
